module.exports = __webpack_public_path__ + "static/img/COVER-5.66a246a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/COVER-5.png
// module id = KcZz
// module chunks = 31